import React from 'react'

import { Separator } from 'twyne-new.ui';

import { formatters } from '../utils';

import Wrapper from './Wrapper';
import { bubbleFormatters } from './formatters';

export default function BubbleToolbar({ editor }) {
  return <Wrapper editor={editor}>
    <div className='flex shrink-0'>
      {formatters.clearFormatter(editor)}
      {bubbleFormatters.titleFormatters(editor)}
      <CustomSeparator />
      {bubbleFormatters.markFormatters(editor)}
      <CustomSeparator />
    </div>
    <div className='flex shrink-0'>
      {bubbleFormatters.alignFormatters(editor)}
      <CustomSeparator />
      {bubbleFormatters.colorFormatters(editor)}
      <CustomSeparator />
      {bubbleFormatters.listFormatters(editor)}
      <CustomSeparator />
    </div>
    <div className='flex shrink-0'>
      {formatters.linkFormatters(editor)}
      <CustomSeparator />
      {bubbleFormatters.tableFormatters(editor)}
    </div>
  </Wrapper>
}

const CustomSeparator = () => <Separator className="border-gray-700! mx-2 h-4" orientation='vertical' />
